import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatasService, Profiles } from '@polylearn/models';
import { of } from 'rxjs';
import { flatMap, tap } from 'rxjs/operators';
import { SwitchLevelDialog } from './components/switch-level-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {
  constructor(
    public dialog: MatDialog,
    private dataService: DatasService,
    private matSnackBar: MatSnackBar
  ) {}

  public getSwitchLevelDialog(profileId: number, level: string) {
    const dialogRef = this.dialog.open(SwitchLevelDialog, {
      width: '250px',
      data: { selectedLevel: level }
    });

    return dialogRef.afterClosed().pipe(
      flatMap(result => {
        console.log('The dialog was closed', result);
        if (result && result !== level) {
          return this.dataService.updateData$(
            'profiles',
            'teacher',
            profileId,
            {
              level: result
            },
            'id'
          );
        }

        return of(undefined);
      }),
      tap(res => {
        if (res) {
          this.matSnackBar.open(
            `Niveau de la plateforme changé avec succès`,
            null,
            {
              duration: 6000
            }
          );
        }
      })
    );
  }
}
